<template>
  <div class="column-span column-span-borders" v-if="showLinks">
    <div class="mb-2 mt-2">
      <label class="mb-1">Profile & Social Media</label>
      <div class="social-media-wrapper">
        <div v-if="userData.transfermarkt" class="d-inline-block mr-3 social-media">
          <a :href="'//'+ userData.transfermarkt.replace('https://', '')" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/tm.png" style="height: 100%; width: 100%;">
          </a>
        </div>
        <div v-if="userData.fupa" class="d-inline-block mr-3 social-media">
          <a :href="'//'+ userData.fupa.replace('https://', '')" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/fupa.png" style="height: 100%; width: 100%;">
          </a>
        </div>
        <div v-if="userData.facebook" class="d-inline-block mr-3">
          <a :href="'//'+ userData.facebook.replace('https://', '')" target="_blank" rel="noopener noreferrer">
            <v-icon large color="#3b5998">mdi-facebook</v-icon>
          </a>
        </div>
        <div v-if="userData.instagram" class="d-inline-block mr-3">
          <a :href="'//'+ userData.instagram.replace('https://', '')" target="_blank" rel="noopener noreferrer">
            <v-icon large color="purple">mdi-instagram</v-icon>
          </a>
        </div>
        <div v-if="userData.website" class="d-inline-block mr-3">
          <a :href="'//'+ userData.website.replace('https://', '')" target="_blank" rel="noopener noreferrer">
            <v-icon large>mdi-web</v-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-links',

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    showLinks() {
      return this.userData.transfermarkt
        || this.userData.fupa
        || this.userData.facebook
        || this.userData.instagram
        || this.userData.website;
    },
  },
};

</script>
